import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import BModal from 'react-bootstrap/Modal';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import Html from '~/commons/components/Html.jsx';
import Modal from '~/commons/components/Modal.jsx';
import Padding from '../layout/Padding.jsx';

async function prepareDownloads(links) {
  let opfsroot= await navigator.storage.getDirectory();
  let videos = [];
  for(var i=0; i<links.length; i++) {
    let video = links[i]
    // console.log('video', video);
    let names = video.split('/');
    let name = names[names.length-1];
    // console.log('name', name)

    let fileHandle = await opfsroot.getFileHandle(name, {create: true});
    // console.log( 'fileHandle', fileHandle )
    
    let file = await fileHandle.getFile();
    // console.log( 'file', file )
    let fileSize = file.size;
    let res = await fetch(video, {method: 'HEAD'});
    // console.log( 'res', res )
    // console.log( 'Content-Length', res.headers.get('Content-Length') );
    let len = Number(res.headers.get('Content-Length'));
    videos.push({src: video, total: len, size: fileSize});
  }
  return videos;
}

async function doDownloadRange({videos, i=0, subTotal = 0, total, cb}) {
  let video = videos[i];
  if ( video ) {
    if ( video.size == video.total ) {
      return doDownloadRange({
        videos, 
        i: i+1,
        subTotal: subTotal+video.size,
        total,
        cb
      });
    }
    let names = video.src.split('/');
    let name = names[names.length-1];
    // if ( name != 'TP-SeVs3d.mp4' ) 
    //   return doDownloadRange(videos);

    let opfsroot= await navigator.storage.getDirectory();
    let fileHandle = await opfsroot.getFileHandle(name, {create: true});
    // console.log( 'fileHandle', fileHandle )

    let fileSize = 0;

    let writable = null; //await fileHandle.createWritable({keepExistingData: file.size > 0});

    console.log('Downloading ... ', names)
    // fetch(video.src, fileSize > 0 ? {cache: "no-store", headers: {'range': 'bytes='+fileSize+'-'}} : {cache: "no-store"})
    return fetch(video.src, fileSize > 0 ? {headers: {'range': 'bytes='+fileSize+'-'}} : undefined)
    .then(async (response)=>{
      // console.log('response', response);
      if ( response.status == 416 ) {
        // console.log('No more data');
        return "done no more";
      }
      let bytesWritten = 0;
      var reader = response.body.getReader()
  
      function readChunk() {
        return reader.read().then(appendChunks)
      }
  
      function appendChunks(result) {
        // console.log( result );
        if ( result.value ) {
          return writable.write(result.value)
          .then(()=>{
            bytesWritten += result.value.length
            let canceled = cb(i, bytesWritten, total, subTotal)
            if ( canceled ) {
              reader.cancel();
              throw 'canceled';
            }
            // console.log('recursing');
            return readChunk();
          })
        }
        if ( result.done ) {
          // console.log('returning');
          return 'done'
        } else {
          // console.log('recursing');
          return readChunk();
        }
      }
  
      writable = await fileHandle.createWritable({keepExistingData: fileSize > 0}); 
      if ( fileSize > 0 ) {
        await writable.seek(fileSize);
      }
      return readChunk();
    })
    .then((code)=>{
      // console.log( 'done file', code )
      return writable ? writable.close() : 'done close';
    })
    .then(()=>{
      return fileHandle.getFile();
    })
    .then((newfile)=>{
      // console.log('newfile', newfile)
      // video.src = URL.createObjectURL(newfile);
      return doDownloadRange({
        videos, 
        i: i+1,
        subTotal: subTotal+newfile.size,
        total, 
        cb
      });
    })
    .catch((err)=>{
      // console.log( 'Download Error', err );
      if ( writable ) {
        writable.close();
      }
      // fileHandle.remove();
      throw err;
    })

  } else {
    console.log('No more to download!')
  }
}

async function handleReDownload(redownload) {
  if ( redownload ) {
    // Remove all cached files.
    await (await navigator.storage.getDirectory()).remove({ recursive: true });
  }
}

const CompetitionSmry = () => {
  const [res, req] = useHttpStatus();
  const [, attemptReq] = useHttpStatus();
  const [startModal, setStartModal] = useState(false);
  const [downloadVideo, setDownloadVideo] = useState(0);
  const [progress, setProgress] = useState();
  const cancelRef = useRef(false);
  const videosRef = useRef();

  useEffect(() => {
    req({ url: 'api/quiz/competitions/self' });
  }, []);

  const downloadVideoMessages = [
    "",
    "",
    "是否下載視訊題目影片？",
    "視訊題目影片已下載， 是否需要重新下載？",
    "視訊題目影片下載中",
    "視訊題目影片下載已完成",
  ];

  const startDownload = (redownload) => {
    cancelRef.current = false;
    setDownloadVideo(4);
    if ( redownload ) {
      videosRef.current.forEach(v=>v.size=0); // Reset size for redownload
    }
    handleReDownload(redownload)
    .then(()=>(
      doDownloadRange({
        videos: videosRef.current, 
        i:0,
        total: videosRef.current.reduce((acc,cur)=>acc+cur.total,0),
        cb: (i, bytesWritten, total, subTotal)=>{
          videosRef.current[i].size = bytesWritten; // Updatre file size.
          // console.log('cb', done, bytesWritten, total, subTotal)
          let progress = Math.floor((subTotal + bytesWritten)*100/total);
          // console.log('progress', progress)
          setProgress(progress);
          return cancelRef.current;
        }
      })
    )).then(()=>{
      console.log('Done');
      // setTimeout(()=>{
      //   setDownloadVideo(5);
      // },500);
    }).catch((err)=>{
      console.log('Download Error', err)
    })
  }

  return (
    <PageHttp res={res}>
      {(comp) => {
        const answer = comp.answers[0];
        const canAnswer = !answer && comp?.allow?.allowed;
        const inProgress = answer
          && !answer.submittedAt
          && moment(answer.createdAt)
            .add(comp.duration, 'm')
            .isAfter();
        if ( comp.videos && comp.videos.length > 0 && downloadVideo == 0 && videosRef.current == null ) {
          prepareDownloads(comp.videos)
          .then((videos)=>{
            console.log('Videos', videos);
            videosRef.current = videos;
            if ( videosRef.current && videosRef.current.length > 0 ) {
              setDownloadVideo(1);
            }
          })
        }
        return (
          <div>
            {/* Modal before start */}
            <Modal
              show={startModal}
              onHide={() => setStartModal(false)}
              centered
            >
              <div className="text-center p-4">
                <div className="text-secondary">{comp.beforeStartMsg}</div>
                <div className="mt-4">
                  <button
                    onClick={() => setStartModal(false)}
                    className="m-2 btn btn-primary btn-fixed-w"
                  >
                    取消
                  </button>
                  <Link
                    to={'/app/competition'}
                    className="m-2 btn btn-outline-primary btn-fixed-w"
                  >
                    確定
                  </Link>
                </div>
              </div>
            </Modal>
            <BModal
              show={downloadVideo>=2}
              onHide={() => {
                if ( downloadVideo != 4 ) {
                  setDownloadVideo(1)
                }
              }}
              centered
              contentClassName="rounded-vm"
            >
              <BModal.Body>
              <div className="text-center p-4">
                <div><img src={`assets/img/video-icon.svg`}/></div>
                <div className="text-secondary py-4">
                  {progress == 100 ? downloadVideoMessages[5] : downloadVideoMessages[downloadVideo] }
                </div>
                {progress !== undefined ? (
                <div className="download-bar">
                  <div className="progress-bar" style={{
                    backgroundImage: `url(assets/img/progress-bar.png)`,
                    backgroundPosition: `${Math.floor(220*progress/100)-220}px 0px`
                  }}>
                  {progress < 100 ? (
                    <img src={`assets/img/progress-head.png`} style={{
                      position: 'absolute',
                      left: `${Math.floor(220*progress/100)}px`,
                      top: '-4px',
                    }}/>
                  ):null}
                  </div>
                  <div className="progress-text">{progress}%</div>
                </div>
                ) : null}
                <div className="mt-4">
                  { (progress === 100 || downloadVideo == 2 || downloadVideo == 3) ? (
                  <button
                    onClick={()=>{
                      if ( progress == 100 ) {
                        return setDownloadVideo(1);
                      }
                      startDownload(downloadVideo === 3);
                    }}
                    className="m-2 btn btn-primary btn-fixed-w"
                  >
                    確定
                  </button>
                  ) : null}
                  { progress != 100 ? (
                  <button
                    onClick={() => {
                      if ( downloadVideo == 4 && progress != 100 ) {
                        cancelRef.current = true;
                        setDownloadVideo(1);
                      // } else 
                      // if ( downloadVideo == 3 ) {
                      //   setDownloadVideo(0);
                      } else {
                        setDownloadVideo(1)
                      }
                    }}
                    className="m-2 btn btn-outline-primary btn-fixed-w"
                  >
                    取消
                  </button>
                  ) : null}
                </div>
              </div>
              </BModal.Body>
            </BModal>
            {comp && (
              <div className="
                assignments-slider
                position-relative m-0
                bg-light
              ">
                {/* cover img */}
                {comp.coverImg && (
                  <div className="container-fluid p-0 pos-abs-fill cover-imgs">
                    <div className="row no-gutters h-100">
                      <div className="col-12 col-lg-8 h-100">
                        <div
                          className="img-bg-cover"
                          style={{
                            backgroundImage: `url('${comp.coverImg}')`,
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                )}
                {/* details */}
                <div className="container-fluid p-0">
                  <div className="row no-gutters justify-content-end">
                    <div className="col-12 col-lg-6 py-4 bg-white">
                      <Padding>
                        <div className="pt-2">
                          {comp.dates && (
                            [comp.dates[0], comp.dates.slice(-1)[0]]
                              .filter((v, i) => comp.dates.indexOf(v) === i)
                              .map((d) => moment(d).format('LL'))
                              .join(' - ')
                          )}
                          &nbsp;
                          <img
                            src={`assets/img/${
                              comp.answers[0]
                                ? 'read.svg'
                                : 'unfinished.svg'
                            }`}
                            style={{ width: '20px' }}
                          />
                        </div>
                        <h2 className="my-3">
                          {comp.title}
                        </h2>
                        <div className="pb-1">
                          <Html>{comp.description}</Html>
                        </div>
                        <div className="text-right mx-n2">
                          {answer && !inProgress && (
                            <a
                              className={`
                                btn btn-primary mx-2 mt-2
                                ${!comp?.allow?.awards ? 'disabled' : ''}
                              `}
                              target="_blank"
                              {...!comp?.allow?.awards ? {
                                disabled: true,
                              } : {
                                href: 'api/quiz/awards',
                              }}
                            >
                              我的電子證書
                            </a>
                          )}
                          {!answer && downloadVideo != 0 ? (
                            <a
                              onClick={()=>{
                                console.log(((videosRef.current||[]).find(v=>(v.size<v.total)) != undefined))
                                let v = videosRef.current.find(v=>(v.size<v.total));
                                console.log( 'v', v )
                                setDownloadVideo(v ? 2 : 3);
                                setProgress(undefined);
                              }}
                              className={`btn btn-primary px-4 py-2 mx-2 mt-2`}
                            >下載影片 <img src={`assets/img/video-dl-icon.svg`}/></a>
                          ) : null}
                          <button
                            onClick={() => {
                              if (canAnswer) {
                                attemptReq({
                                  method: 'post',
                                  url: 'api/quiz/answers/attempt',
                                });
                                setStartModal(true);
                              }
                            }}
                            className={`
                              btn btn-${!canAnswer ? 'light' : 'primary'}
                              px-4 py-2 mx-2 mt-2
                              ${!canAnswer ? 'disabled' : ''}
                            `}
                            disabled={!canAnswer || ((videosRef.current||[]).find(v=>(v.size<v.total)) != undefined)}
                          >
                            {!canAnswer && (
                              inProgress ? '比賽進行中' : comp.completedMsg
                            )}
                            {canAnswer && '開始作答'}
                            &nbsp;
                            {canAnswer && (
                              <img
                                className="mr-3"
                                src={`assets/img/long-arrow-right${comp.answers[0] ? '-blk' : ''}.svg`}
                                style={{ width: '38px', height: '9px' }}
                              />
                            )}
                        </button>
                        </div>
                      </Padding>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      }}
    </PageHttp>
  );
};

export default CompetitionSmry;
